export const PriceBig = {
  fontSize: {
    xs: '24px',
    sm: '32px',
    md: '36px',
    lg: '42px',
    xl: '48px'
  },
  lineHeight: {
    xs: '28px',
    sm: '36px',
    md: '40px',
    lg: '46px',
    xl: '52px'
  }
};